export const GET_DOMESTICBANK = "GET_DOMESTICBANK"
export const GET_DOMESTICBANK_SUCCESS = "GET_DOMESTICBANK_SUCCESS"
export const GET_DOMESTICBANK_FAIL = "GET_DOMESTICBANK_FAIL"

export const GET_DOMESTICBANKS_BY_USERNAME = "GET_DOMESTICBANKS_BY_USERNAME"
export const GET_DOMESTICBANKS_BY_USERNAME_SUCCESS = "GET_DOMESTICBANKS_BY_USERNAME_SUCCESS"
export const GET_DOMESTICBANKS_BY_USERNAME_FAIL = "GET_DOMESTICBANKS_BY_USERNAME_FAIL"

export const DOMESTICBANK_API_ERROR = "DOMESTICBANK_API_ERROR"